import React from "react";
import moment from "moment";
import GatsbyConfig from "../../../gatsby-config.js";
import {
  setInLocal,
  buildPerksHTMLforTrip,
  scrollDistanceToTop,
  getParamFromQueryString,
} from "../../utils/app-helpers";
import BookmarkArrow from "../partials/bookmark-arrow";
import Countdown from "../partials/countdown";
import DestinationCallout from "../partials/destination-callout";
import HelmetWrapper from "../partials/helmet-wrapper";
import Lineup from "../partials/lineup";
import Message from "../partials/message";
import MonthlyPaymentsCallout from "../partials/monthly-payments-callout";
import NewsletterCallout from "../partials/newsletter-callout";
import OnLocationContent from "../partials/onlocation-content";
import OnLocationHeader from "../partials/onlocation-header";
import OnLocationBanner from "../partials/onlocation-banner";
import PriceGuarantee from "../partials/price-guarantee";
import SiteFooter from "../partials/site-footer";
import TabbedContent from "../partials/tabbed-content";
import ThinBar from "../partials/thin-bar";
import TripHeader from "../partials/trip-header";

const { siteMetadata: config } = GatsbyConfig;

export default class OnLocationPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;

    setInLocal("lsg.last-viewed-trip", trip);
  }

  render() {
    const { trip, location, metaTitle, metaDescription } = this.props;
    if (!trip || typeof window === "undefined") return <main />;
    const tripData = config.trips[trip];
    const perksHTML = buildPerksHTMLforTrip(tripData);
    const selectedKey =
      location && location.search.match(/tab=[^&]+/i)
        ? location.search.replace(/.*\??tab=([^&]+).*/g, "$1")
        : "rooms";
    const title =
      "Christian Couples Getaway in Kauai, Hawaii | Love Song Getaway 2019";
    const description =
      "Join us on the trip of a lifetime at The Grand Hyatt Kauai, Hawaii! " +
      "Check out the Love Song Couples Getaway | Kauai, Hawaii 2019. Musical " +
      "performances by Newsboys, speaking sessions, and more to be announced!";
    const cutoffDateUTC = moment.utc(tripData.onLocationPricingCutoff);
    const countdownDate = cutoffDateUTC
      .utcOffset(moment().utcOffset())
      .valueOf();
    const tab = getParamFromQueryString("tab", window.location.href);

    if (!!tab) {
      setTimeout(
        () => window.scrollTo(0, scrollDistanceToTop(this.refs.tabbedContent)),
        100
      );
    }
    return (
      <div className={`page-onlocation big-header trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <OnLocationHeader trip={trip} />
        <div className="bookmark" id="top" />
        <TripHeader trip={trip} />
        <div
          style={{ backgroundImage: `url(/images/prices-${trip}-splash.jpg)` }}
          className="image mobile-100x40 desktop-300"
        />
        <OnLocationContent trip={trip}>
          <main>
            <OnLocationBanner trip={trip} showExtra />
            <Countdown date={countdownDate} />
            <ThinBar message="Exclusive Discount Reflected Below" />
            {tripData.onLocationMessage ? (
              <Message>{tripData.onLocationMessage}</Message>
            ) : (
              ""
            )}
            <div ref="tabbedContent">
              <TabbedContent
                willAnchor
                navHeight={75}
                replaceState={`/${trip}/onlocation/`}
                selectedKey={selectedKey}
                data={JSON.stringify([
                  {
                    key: "rooms",
                    name: "Rooms",
                    slug: "",
                    component: "Rooms",
                    props: { trip, kind: "room" },
                  },
                  {
                    key: "suites",
                    name: "Suites",
                    slug: "?tab=suites",
                    component: "Rooms",
                    props: { trip, kind: "suite" },
                  },
                  {
                    key: "all",
                    name: "All",
                    slug: "?tab=all",
                    component: "Rooms",
                    props: { trip },
                  },
                ])}
              />
            </div>
            {!tripData.disableMonthlyPaymentOption && (
              <MonthlyPaymentsCallout
                trip={trip}
                validUntil={cutoffDateUTC.utcOffset(-7)}
              />
            )}
            <div className="room-perks">
              <div className="wrap">
                <div className="whats-included">
                  <h3>What’s Included</h3>
                  <div dangerouslySetInnerHTML={{ __html: perksHTML }} />
                </div>
                {trip !== "cancun" && <PriceGuarantee venue={tripData.venue} />}
              </div>
            </div>
            <div className="content">
              <div className="wrap">
                <p>
                  {tripData.disableMonthlyPaymentOption
                    ? config.doubleOccupancyDisclaimerNoMonthly
                    : config.doubleOccupancyDisclaimer}
                </p>
              </div>
              <div className="wrap">
                <Lineup trip={trip} location={this.props.location} />
              </div>
            </div>
            <DestinationCallout trip={trip} />
            <NewsletterCallout
              trip={trip}
              requireFirstName={tripData.requireFirstNameForNewsletter}
              requireLastName={tripData.requireLastNameForNewsletter}
              analyticsLocation="onlocation"
            />
            <div className="content">
              <div className="wrap arrow-bar">
                <BookmarkArrow bookmark="top" direction="up" />
              </div>
            </div>
          </main>
        </OnLocationContent>
        <SiteFooter trip={trip} hideTrips />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/onlocation.js